import { AccessGroupModule, IResourcePermissionType } from '@carm/features/private/setup-my-portal/employees-access-mgt/models/grant-access.model';
import { IGetRowsResult } from '@carm/shared/components/table/table-ag-grid/models/table-actions-model';
import { AccessGroup, IPaginate, ISortProgramById } from '@carm/_core';
import { IErrorResponse } from '@carm/_utils/models';

export interface User {
  firstName?: string;
  lastName?: string;
  preferredLanguage?: string;
  displayUserId?: string;
  userId: string;
  isDefaultAddressExist: boolean;
  lastLogout: Date;
  isPrivacyTermsConditionsAccepted: boolean;
  isPrivacyTermsConditionsAPIAccepted?: boolean;
}

export interface UserRole {
  business: Business;
  roles: Role[];
  lastUsedRole: Role;
}

export interface Role {
  roleType: RoleTypes;
  roleName: string;
  isNative?: boolean;
  program: Program;
}

export interface IBusinessListResponse extends IGetRowsResult, IErrorResponse {
  results: Business[];
  pagination?: IPaginate;
}

export interface Business {
  legalName: string;
  operatingName: string;
  uid: string;
}

export interface Program extends ISortProgramById{
  programType: ProgramTypes;
  name?: string;
  operatingName?: string;
  companyName?: string;
  companyUid?: string;
  programAreaId?: string;
  programSubType?: string;
}

export enum ProgramTypes {
  Importer = '09',
  ImporterR1 = 'IMP',
  Exporter = 'EXP',
  ImporterExporter = '14',
  MCIT = '15',
  Trade = 'Trade',
  CustomsBroker = 'BRO', // 'CUSTOMER-BROKER',
  DutyFreeShop = 'DFS',
  Carriers = 'CC',
  Warehouse = 'WHSE',
  ThirdPartyServiceProvider = 'TPFE',
  ThirdPartyServiceProviderEDI = 'TPED',
  ThirdPartyServiceProviderSurety = 'TPSC',
  ThirdPartyServiceProviderAcountant = 'TPTA',
  ThirdPartyServiceProviderLawyer = 'TPTL',
  ThirdPartyServiceProviderConsultant = 'TPTC',
  CSA = 'CSA',
  OtherGovernmentDepartment = 'OGDS',
  PGIM = 'PGIM',
  ALL = 'ALL'
}

export enum RoleTypes {
  BusinessAccountManager = 'BUSINESS_ACCOUNT_MANAGER',
  ProgramAccountManager = 'PROGRAM_ACCOUNT_MANAGER',
  ThirdPartyProgramAccountManager = 'THIRD_PARTY_PROGRAM_ACCOUNT_MANAGER',
  ThirdPartyBusinessAccountManager = 'THIRD_PARTY_BUSINESS_ACCOUNT_MANAGER',
  ReadOnly = 'READ_ONLY',
  ThirdPartyReadOnly = 'THIRD_PARTY_READ_ONLY',
  EditRead = 'EDIT_READ',
  ThirdPartyEditRead = 'THIRD_PARTY_EDIT_READ',
  BrokerBusinessAccountManager = 'BROKER_BUSINESS_ACCOUNT_MANAGER',
  BrokerProgramAccountMananger = 'BROKER_PROGRAM_ACCOUNT_MANAGER',
  BrokerEditRead = 'BROKER_EDIT_READ',
  BrokerReadOnly = 'BROKER_READ_ONLY',
  Orphan = 'ORPHAN',
}

export const THIRD_PARTY_ROLES = [RoleTypes.ThirdPartyBusinessAccountManager, RoleTypes.ThirdPartyProgramAccountManager];

export interface CompanyRole {
  companyUid: string;
  companyName: string;
  roleType: string;
  isNativeCompany: boolean;
}
export interface UserBusinessPrograms {
  business: CompanyRole;
  programs: Program[];
}

export interface IProgramAccessItem extends Program {
  programPermissions?: { accessGroupModule: AccessGroupModule, resources: IResourcePermissionType[], onlyDisplayAccessGroup?: boolean; }[];
  displayingPermissions: boolean;
  accessGroup?: AccessGroup;
}
